import React from 'react'
import "./category.css"
import { useNavigate } from 'react-router-dom'

function Category({categories}: any) {

  const navigate = useNavigate();

  return (
    <div className='shop-by-category'>
      <div className="categories">
          {categories?.data?.map((item: any) => (
            
            <div key={item.id} className="category" onClick={() => navigate(`/category/${item.id}`)}>
              <img src={item.attributes.img.data.attributes.url} alt="" />
            </div>
          ))}
      </div>
    </div>
  )
}
export default Category
